import { render } from "./NewsIndex.vue?vue&type=template&id=2ecfcd0d&scoped=true"
import script from "./NewsIndex.vue?vue&type=script&lang=js"
export * from "./NewsIndex.vue?vue&type=script&lang=js"

import "./NewsIndex.vue?vue&type=style&index=0&id=2ecfcd0d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecfcd0d"]])

export default __exports__